import type { HttpAuthPolicy } from '@shared/api/http';
import {
  clearSession,
  persistAccessToken,
  readAccessToken,
  readRefreshToken,
} from '../infrastructure/sessionStorage';

export function createIamHttpAuthPolicy(): HttpAuthPolicy {
  return {
    readAccessToken,
    readRefreshToken,
    persistAccessToken,
    clearSession,
  };
}